/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Row, Col, Skeleton, Card, message } from "antd";
import { Map, TileLayer } from "react-leaflet";
import Control from "react-leaflet-control";
import Layout from "../../../layouts/MocoLayout";
import { NavigationMenuCard } from "../../../components/ui";
import { MocoCard } from "../../../components/widget";
import oRest from "../../../apis/rest";
import EventMarker from "./MarkerCluster";
import config from "./index.config";
import "./index.scss";

const MAP_URL = `https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAP_API_KEY}`;
const ATTRIBUTION =
  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: countAll } = await oRest.get(
          `${API_URL}kemenag_count_all_pondok_pesantren`
        );
        const { data: countFilled } = await oRest.get(
          `${API_URL}kemenag_count_filled_pondok_pesantren`
        );

        setCounts({
          all: countAll[0].count,
          filled: countFilled[0].count,
          percent: ((countFilled[0].count / countAll[0].count) * 100).toFixed(
            2
          ),
        });
      } catch (error) {
        message.error("Terjadi kesalahan");
        console.log(error);
      }
    };
    fetchData();
  }, []);

  return (
    <Layout bgColor="#1B6FBA">
      <Col span={24}>
        <NavigationMenuCard
          menu={[
            { title: "Sebaran", path: "/pondok-pesantren" },
            { title: "Pendidikan", path: "/pondok-pesantren/pendidikan" },
            { title: "Dakwah", path: "/pondok-pesantren/dakwah" },
            {
              title: "Pemberdayaan Masyarakat",
              path: "/pondok-pesantren/pemberdayaan-masyarakat",
            },
            {
              title: "Penyajian dan Pencarian",
              path: "/pondok-pesantren/penyajian-pencarian",
            },
          ]}
        />
      </Col>
      <Row
        justify="center"
        align="top"
        className="Map__row"
        gutter={[24, 24]}
        style={{
          marginBottom: 24,
        }}
      >
        <Col span={24} style={{ maxHeight: 1080, paddingTop: "3vh" }}>
          <MocoCard {...config.cards.map.content}>
            <Skeleton loading={!counts}>
              <Map
                center={config.cards.map.options.center}
                zoom={5}
                minZoom={5}
                maxZoom={19}
              >
                <TileLayer attribution={ATTRIBUTION} url={MAP_URL} />
                <Control position="bottomright">
                  <Card>
                    <div>Penyajian Data</div>
                    <div className="text-header">{`${counts?.percent}%`}</div>
                    <div>{`${counts?.filled} / ${counts?.all} Pesantren`}</div>
                  </Card>
                </Control>
                <EventMarker />
              </Map>
            </Skeleton>
          </MocoCard>
        </Col>
      </Row>
    </Layout>
  );
};

export default Page;
